import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import { Container } from '@mui/system';
import { Link } from 'react-router-dom';
import { Class, HouseRounded, People, QuestionAnswer } from '@mui/icons-material';

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export default function Navigation({ children, heading, data }) {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  let roler = localStorage.getItem("role")
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position='fixed'
        open={open}
        color='transparent'
        elevation='false'
      >
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            edge='start'
            sx={{ mr: 2, ...(open && { display: 'none' }) }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant='h5' noWrap component='div'>
            {heading}
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant='persistent'
        anchor='left'
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>

        <List>
        
          <NavigationButtons
            linkTo='/dashboard'
            title='Dashboard'
            icon={<InboxIcon />}
          />
         
          {roler === "school" ? <NavigationButtons
            linkTo='/finances'
            title='Finances'
            icon={<HouseRounded />}
          /> : null

          }
          
            {roler === "school" || roler === "teacher" ? <NavigationButtons
            linkTo='/classes'
            title='Classes'
            icon={<Class />}
          /> : null

          }

        {roler === "school" || roler === "teacher" ?  <NavigationButtons
          linkTo='/allstudents'
          title='Students'
          icon={<People />}
        /> : null

          }

        {roler === "school" || roler === "teacher" ?  <NavigationButtons
            linkTo='/allteachers'
            title='Teachers'
            icon={<People />}
          /> : null

          }
         
         
          
          
        </List>
        <Divider />


        {roler === "school" ? <NavigationButtons
          linkTo='/add-teacher'
          title='Add Teacher'
          icon={<InboxIcon />}
        /> : null

          }

        {roler === "school" || roler === "teacher" ?  <NavigationButtons
          linkTo='/add-student'
          title='Add Student'
          icon={<InboxIcon />}
        /> : null

          }
        
        {roler === "Student" ?  <NavigationButtons
          linkTo='/questionnaire'
          title='Questionnaire'
          icon={<QuestionAnswer />}
        /> : null

          }
          
        



        <Divider />
        <NavigationButtons
          onClick={() => {
            localStorage.clear();
            window.location.href = '/';
          }}
          title='Logout'
          icon={<InboxIcon />}
        />
      </Drawer>

      <Main open={open}>
        <Container
          maxwidth='sm'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Container>
      </Main>
    </Box>
  );
}

function NavigationButtons(props) {
  return (
    <Link style={{ textDecoration: 'none' }} to={props.linkTo}>
      <ListItemButton onClick={props.onClick || undefined}>
        <ListItemIcon style={{ color: '#8767A8' }}>{props.icon}</ListItemIcon>
        <ListItemText primary={props.title} />
      </ListItemButton>
    </Link>
  );
}
